import directives from '../module';
import {Utils} from 'underscore-extensions';
import {StopPlaySvc} from '../../services/StopPlaySvc';
import {Observer} from '../../services/ViewPortSvc';
import {WistiaSvc} from '../../services/WistiaSvc';

class LandingPage {
    videoOptions = {
        volume: 0
    };

    video: anm.LandingVideo = {
        wistiaId: '0mvyjstgpk',
        preview: 'https://assets.animatron.com/images/landing/video-previews/studio_preview.jpg'
    };

    private static readonly animationActiveClz = 'stager--active';

    readonly tabs = ['startup', 'teachers', 'animators', 'everyone'];

    tabChange() {
        const selectors               = '.tabs-animated-content, .quote-wrapper';
        const all: Array<HTMLElement> = [].slice.call(document.querySelectorAll(selectors));
        all.forEach(el => el.classList.remove(LandingPage.animationActiveClz));
        setTimeout(() => Utils.rAF(() =>
            all.forEach(el => el.classList.add(LandingPage.animationActiveClz)))
        );
    }
}

directives.component('landingPage', {
    controller: LandingPage,
    templateUrl: require('landing/landing-new.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/landing/LandingPage.ts